export default __webpack_public_path__ + "static/media/ic-check-filled.90a9fa0c.svg";